module.exports = __webpack_public_path__ + "static/img/livedownload.7df6520.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/offcn-teacher-downloads/livedownload.png
// module id = U/5u
// module chunks = 1